// src/components/chat/EditIndicator.jsx
import React from 'react';
import './EditIndicator.css';

const EditIndicator = ({ editingMessage, onCancel }) => {
    if (!editingMessage) return null;

    return (
        <div className="edit-indicator">
            <div className="edit-indicator-header">
                <i className="bi bi-pencil-square"></i>
                Редактирование...
                <button onClick={onCancel}>
                    <i className="bi bi-x"></i>
                </button>
            </div>
            <div className="edit-indicator-content">
                {editingMessage.content?.substring(0, 50)}
                {editingMessage.content?.length > 50 && '...'}
            </div>
        </div>
    );
};

export default EditIndicator;